module.exports = __webpack_public_path__ + "static/media/01.db5f77e2.mp3";